import { BaseApi } from '@Features/Base/BaseApi/BaseApi'
import { toQueryString as toQS } from '@Utilities/toQueryString'

export type SearchQueryArgs = {
	query?: string
	category?: string | number
	education_type?: string | number
	education_year?: string | number
	education_section?: string | number
	education_language?: string | number
	page?: string | number
	per_page?: number
	limit?: number
	types?: string
}

export const searchApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		searchAll: builder.query<ApiResponse<SearchAllData> & { meta: SearchAllMeta }, SearchQueryArgs>({
			query: args => `/search?${toQS({ types: 'classrooms,instructors', limit: 8, ...args })}`,
		}),
		searchClassrooms: builder.query<ApiResponse<Classroom[]>, SearchQueryArgs>({
			query: args => `/search/classrooms?${toQS({ per_page: 12, ...args })}`,
		}),
		searchInstructors: builder.query<ApiResponse<BriefInstructor[]>, SearchQueryArgs>({
			query: args => `/search/instructors?${toQS({ per_page: 12, ...args })}`,
		}),
		searchCourses: builder.query<ApiResponse<StandaloneCourse[]>, SearchQueryArgs>({
			query: args => `/search/courses?${toQS({ per_page: 12, ...args })}`,
		}),
		// Bundles are a dedicated tab (in the combined /search only via an
		// explicit types=...,bundles opt-in). Education filters match through
		// the bundle's active member courses server-side; category matches the
		// bundle itself. The payload merges owned/enrollment/buyable_now
		// server-side, same shape as /bundles.
		searchBundles: builder.query<ApiResponse<Bundle[]>, SearchQueryArgs>({
			query: args => `/search/bundles?${toQS({ per_page: 12, ...args })}`,
		}),
		getSearchCategories: builder.query<ApiResponse<Category[]>, void>({
			query: () => '/categories',
		}),
		getEducationInfo: builder.query<ApiResponse<EducationInfoType[]>, void>({
			query: () => '/education/info',
		}),
	}),
})

export const {
	useSearchAllQuery,
	useSearchClassroomsQuery,
	useSearchInstructorsQuery,
	useSearchCoursesQuery,
	useSearchBundlesQuery,
	useGetSearchCategoriesQuery,
	useGetEducationInfoQuery,
} = searchApi
